import { createSelector } from 'reselect'

import { State } from '../../../types/reduxSaga-deprecated'

export const selectProvidedOrganizationIdOrDefault = createSelector(
  (state: State) => state.app.organization,
  (_: unknown, providedOrganizationId: string | undefined) => providedOrganizationId,
  (organization, providedOrganizationId: string | undefined) => providedOrganizationId || organization?.id,
)
